import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { showingbookerAPI } from '../../../services/showingbookerAPI';

const Container = styled.div`
  padding: 20px;
`;

const Header = styled.div`
  margin-bottom: 30px;
`;

const Title = styled.h2`
  margin: 0;
  color: #333;
  font-size: 24px;
`;


const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const TableHeader = styled.th`
  background: #f8f9fa;
  padding: 15px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #dee2e6;
`;

const TableRow = styled.tr`
  &:hover {
    background: #f8f9fa;
  }
`;

const TableCell = styled.td`
  padding: 15px;
  border-bottom: 1px solid #dee2e6;
  color: #333;
`;

const ContactLink = styled.a`
  color: #007AFF;
  text-decoration: none;
  display: block;
  margin-bottom: 4px;
  
  &:hover {
    text-decoration: underline;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;



const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
  
  h3 {
    margin-bottom: 10px;
  }
  
  p {
    margin-bottom: 20px;
  }
`;

const Agents = () => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAgents();
  }, []);

  const loadAgents = async () => {
    try {
      const data = await showingbookerAPI.getAgentsContacts();
      setAgents(data);
    } catch (error) {
      console.error('Error loading agents:', error);
    } finally {
      setLoading(false);
    }
  };


  if (loading) {
    return (
      <Container>
        <LoadingMessage>Loading agents...</LoadingMessage>
      </Container>
    );
  }

  return (
    <Container>
      <Header>
        <Title>🤝 Buyer Agents from Showings ({agents.length})</Title>
        <p style={{ color: '#666', margin: '8px 0 0 0', fontSize: '14px' }}>
          Agents who brought buyers to view your properties
        </p>
      </Header>

      {agents.length === 0 ? (
        <EmptyState>
          <div style={{ fontSize: '48px', marginBottom: '16px', opacity: '0.5' }}>🤝</div>
          <h3>No Buyer Agents Yet</h3>
          <p>Agents who bring buyers to your property showings will appear here automatically for tracking and follow-up.</p>
        </EmptyState>
      ) : (
        <Table>
          <thead>
            <tr>
              <TableHeader>Name</TableHeader>
              <TableHeader>Contact</TableHeader>
              <TableHeader>License</TableHeader>
              <TableHeader>Brokerage</TableHeader>
              <TableHeader>Specialties</TableHeader>
              <TableHeader>Source</TableHeader>
            </tr>
          </thead>
          <tbody>
            {agents.map((agent) => (
              <TableRow key={agent.id}>
                <TableCell>
                  <strong>{agent.first_name} {agent.last_name}</strong>
                </TableCell>
                <TableCell>
                  {agent.email && (
                    <ContactLink href={`mailto:${agent.email}`}>
                      {agent.email}
                    </ContactLink>
                  )}
                  {agent.phone && (
                    <ContactLink href={`tel:${agent.phone}`}>
                      {agent.phone}
                    </ContactLink>
                  )}
                </TableCell>
                <TableCell>{agent.license_number || 'N/A'}</TableCell>
                <TableCell>{agent.brokerage_name || 'N/A'}</TableCell>
                <TableCell>{agent.specialties || 'N/A'}</TableCell>
                <TableCell>
                  <div style={{ 
                    color: '#666', 
                    fontSize: '14px',
                    fontStyle: 'italic'
                  }}>
                    ShowingBooker
                  </div>
                  {agent.created_at && (
                    <div style={{ 
                      color: '#999', 
                      fontSize: '12px' 
                    }}>
                      {new Date(agent.created_at).toLocaleDateString()}
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </tbody>
        </Table>
      )}

    </Container>
  );
};

export default Agents;